import { Box } from "@mui/material";
import { useState } from "react";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { userManagementUrl } from "../../../config";

const base_url = userManagementUrl.uri;
const UserAuditsQuery = `{
   allUsersAudit {
    approvedBy
    approvedByUsername
    approvedDate
    auditDate
    auditedUsername
    auditId
    branchId
    changedColumns
    changedData
    changePassword
    clientIP
    companyId
    companyName
    countryId
    createdBy
    createdByUsername
    createdDate
    dbUser
    deactivateBy
    deactivateByUsername
    deactivateDate
    departmentId
    firstTimeLogin
    isActive
    isOnLeave
    isPasswordExpiredAt
    isSupervisor
    lastLogin
    loginAttempts
    newData
    oldData
    operation
    passwordChangedAt
    passwordExpiresAt
    pwdRemDays
    reason
    regionId
    registrationStatus
    roleGroup
    roleGroupId
    roleId
    roleName
    source
    updatedBy
    updatedByUsername
    updatedDate
    userId
    userMasterId
    username
  }
  }
`;
const actions = {
  entity: "UserAudit",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: false,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: false,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button:false,
    permission: "ActivatePermission",
    modelName: "colorIds",
    inputObjectName: "bulkActivateDeactivateColor",
  },
  showMore: {
    key: "SHOWMORE",
    button_name: "Show More",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
    title: "Inventory Details"
  },
  showStatus: true,
};
const ignore = [ "branchId","approvedBy","approvedDate","approvedByUsername","DeactivateBy","DeactivateByUsername","DeactivateDate","firstTimeLogin",
  "changedColumns", "clientIP", "companyId", "dbUser",
    "inventoryUpdatedBy", "productId", "regionId", "source", "updatedBy","createdBy","lastLoginAttempts","isPasswordExpiredAt","isSupervisor"
    ,"passwordChangedAt","passwordExpiresAt","pwdRemDays",
    "registrationStatus","roleGroup","roleGroupId","roleId",
    "userId", "newData", "oldData", "purchaseOrderItemsId" ,"reason"];

function UserAuditsTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  return (
    <Box m="2px">
      <DynamicTable
        title="User Audits"
        subtitle="Manage user audits"
        query={UserAuditsQuery}
        base_url={base_url}
        ignoreFields={ignore}
        actions={actions}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        getRowId={(row) => row.auditId}

      />
    </Box>
  );
}

export default UserAuditsTable;
